import * as SwitchPrimitives from '@radix-ui/react-switch';
import React from 'react';
import {
  SwitchVariants,
  ThumbVariants,
  type SwitchSize,
  type SwitchVariant,
} from './switch.variants';
import { cn } from '@/shared/lib/cn';

const variantGroupColors: Record<SwitchVariant, string> = {
  default: cn(
    'group-data-[state=checked]:group-hover:bg-switch-thumb-unchecked/30',
    'group-data-[state=unchecked]:group-hover:bg-switch-thumb-unchecked/30',
    'group-data-[state=checked]:group-active:bg-switch-thumb-unchecked/30',
    'group-data-[state=unchecked]:group-active:bg-switch-thumb-unchecked/30',
    'disabled:opacity-0',
  ),
};

const hoverSizes = {
  default: 'w-9 h-9',
};
const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & {
    variant?: SwitchVariant;
    size?: SwitchSize;
    label?: string;
  }
>(({ className, variant = 'default', size = 'default', disabled, label, ...props }, ref) => (
  <div className={`flex items-center ${label ? 'gap-5' : ''}`}>
    <SwitchPrimitives.Root
      className={cn(
        SwitchVariants({ variant, size }),
        'group relative',
        disabled && 'cursor-not-allowed',
        className,
      )}
      {...props}
      ref={ref}
      disabled={disabled}
    >
      <SwitchPrimitives.Thumb className={cn(ThumbVariants({ variant, size }))}>
        {!disabled && (
          <div
            className={cn(
              variantGroupColors[variant],
              'absolute -inset-3 flex -left-2.5 -top-2.5 items-center justify-center rounded-full opacity-0 group-hover:opacity-100 group-active:opacity-30 transition-opacity duration-0',
              hoverSizes[size],
            )}
          />
        )}
      </SwitchPrimitives.Thumb>
    </SwitchPrimitives.Root>
    <span className="text-light-secondary text-xs">{label}</span>
  </div>
));

Switch.displayName = 'Switch';

export { Switch };
